import { Component, Input } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import {Store} from "../../services/store.service";

@Component({
  selector: "tab-menu",
  templateUrl: "./tab-menu.component.html",
})
export class TabMenu {

  @Input() public items: any[] = [];
  @Input() public baseUrl: string = "";
  @Input() public subMenu: boolean = false;
  @Input() public backToList: boolean = false;

  constructor(public store: Store,
              private router: Router,
              private route: ActivatedRoute) {}

  public resetSections() {
    this.store.state.common.sections.reset();
    this.store.state.common.determinantSection.reset();
  }

}
